import { render, staticRenderFns } from "./AficionVisitanteModal.vue?vue&type=template&id=5e87e9e3&scoped=true"
import script from "./AficionVisitanteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AficionVisitanteModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AficionVisitanteModal.vue?vue&type=style&index=0&id=5e87e9e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e87e9e3",
  null
  
)

export default component.exports